/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import {
  TableDefault,
  TableHead,
  DarkStickyMainHeader,
  TableBody,
  TableRow,
  SortArrow,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
  TableColumn,
  ArrowHolderSummary,
  DarkStickyShadowMainHeader,
  ColumnContainerSummary,
  WrapperSortingTableHead,
  FeatureLocked,
  TextFeatureLocked,
  TitleFeatureLocked
} from './styles';
import { Radio, InputCheckbox, SelectPlayerColumn } from '..';
import Utils, { deepGet } from '../../utils/api/Utils';
import { capitalizeFirstLetters } from '../../utils/hooks/text-formatter';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';
import TooltipFatigueZones from '../TooltipFatigueZones/TooltipFatigueZones';
import { ArmFatigue, ArmStrength } from '../../utils/constants/fatigueZonesInfo';
import { Oval } from '../../pages/players/styles';
import { handleDate } from '../../utils/helpers/handleDate';

function PopUp ({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
  medical,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
  medical?: boolean;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({ one: false, two: false });
  const [check, useCheck] = useState<any>({ zone_1: false, zone_2: false, zone_3: false });

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }
    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  function buildFilter () {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'zone 1';
      }
      if (item === 'zone_2') {
        item = 'zone 2';
      }
      if (item === 'zone_3') {
        item = 'zone 3';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }

  function HandleRadioSort (e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = { one: true, two: false };
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = { one: false, two: true };
      useReverse(true);
      useRadio(ascendent);
    }
  }

  if (visible === popup_id) {
    return (
      <SortPopUp posY={46}>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{ border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px' }} />
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })}>Watch</PopUpText>
              <Oval size={'16'} color={'watch'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })}>Warning</PopUpText>
              <Oval size={'16'} color={'warning'} />
            </CheckBoxWrapper>
            {medical && (
              <CheckBoxWrapper>
                <InputCheckbox checked={check.zone_3} onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })} />
                <PopUpText onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })}>Medical</PopUpText>
                <Oval size={'16'} color={'medical'} />
              </CheckBoxWrapper>
            )}
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}

export default ({
  dataTableContent,
  filter,
  dataCy,
  onSort,
  sortBy,
  sortOrder,
}: {
  dataTableContent: Array<any>;
  filter: string;
  dataCy?: string;
  team?: string;
  onSort: (column: string) => void;
  sortBy: string;
  sortOrder: string;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [popUp, usePopup] = useState<string>('');
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(true);
  const sortOptions = [!reverse, changeTable, table];
  const [tooltipSection, setTooltipSection] = useState<any>([ArmStrength, 'totalStrength']);
  const tooltipRef = useRef<HTMLInputElement | any>(document.createElement('div'));
  const UTILS = new Utils();

  useEffect(()=>{
    useTable([...dataTableContent]);
  }, [dataTableContent])
  useEffect(() => {
    toggleSortDate('date', ['data', 'date']);
  }, []);

  function changeTable (e) {
    useTable([...e]);
  }
  function togglePopUp (selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }

  function toggleSort (sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, [!reverse, changeTable, table]);
  }

  function toggleSortDate (sort, params) {
    useSort(sort);
    useReverse(!reverse);
  }

  function closeSorts () {
    usePopup('');
    useSort('');
  }

  function hoverOval (event, tooltipInfo) {
    let top = Number(event.clientY) + 10;
    let left = Number(event.clientX) + 10;
    if (Number(window.innerWidth) - Number(event.clientX) < 300) {
      left = Number(event.clientX) - 200;
    }
    if (Number(window.innerHeight) - Number(event.clientY) < 180) {
      top = Number(event.clientY) - 112;
    }
    tooltipRef.current.style.display = 'block';
    tooltipRef.current.style.inset = top + 'px 0px 0px ' + left + 'px';
    setTooltipSection(tooltipInfo);
  }

  function hideTooltip () {
    tooltipRef.current.style.display = 'none';
  }

  function SortingTable ({ title = '', attr, location, bgColor = '', sortFunction }) {
    return (
      <WrapperSortingTableHead bgColor={bgColor} onClick={() => onSort(attr)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sortBy === attr && sortOrder === 'asc' && <GoChevronUp size={14} />}
            {sortBy === attr && sortOrder === 'desc' && <GoChevronDown size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </WrapperSortingTableHead>
    );
  }

  function toggleSortString (sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  function toggleSortNumber (sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }

  return (
    <>
      <TableDefault data-cy={dataCy} minWidth={'1360px'}>
        <TableHead>
          <TableRow>
            <DarkStickyMainHeader colSpan={1}></DarkStickyMainHeader>
            <DarkStickyShadowMainHeader colSpan={1}>POST EXAM</DarkStickyShadowMainHeader>
            <DarkStickyMainHeader colSpan={3}>EVENT</DarkStickyMainHeader>
            <DarkStickyMainHeader colSpan={2}>TOTAL STRENGTH</DarkStickyMainHeader>
            <DarkStickyShadowMainHeader colSpan={2}>INTERNAL ROTATION</DarkStickyShadowMainHeader>
            <DarkStickyMainHeader colSpan={2}>EXTERNAL ROTATION</DarkStickyMainHeader>
            <DarkStickyShadowMainHeader colSpan={2}>SCAPTION</DarkStickyShadowMainHeader>
            <DarkStickyMainHeader colSpan={2}>GRIP</DarkStickyMainHeader>
          </TableRow>
          <TableRow>
            <WrapperSortingTableHead bgColor={'#f7f8fa'} onClick={() => onSort('playerName')}>
              <SortArrow>
                <span>Player name</span>
                {sortBy === 'playerName' && sortOrder === 'asc' && <GoChevronUp size={14} />}
                {sortBy === 'playerName' && sortOrder === 'desc' && <GoChevronDown size={14} />}
              </SortArrow>
            </WrapperSortingTableHead>
            <SortingTable title="Sort date" attr="date" location={['data', 'date']} bgColor={'#ebedf2'} sortFunction={toggleSortDate} />
            <SortingTable title="Type" attr="type" location={['data', 'event', 'type']} bgColor={'#f7f8fa'} sortFunction={toggleSortString} />
            <WrapperSortingTableHead bgColor={'#f7f8fa'}>
              <span onClick={() => togglePopUp('pu_0')}>Pitches</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['data', 'event', 'pitches']}
                popup_id={'pu_0'}
                visible={popUp} />
            </WrapperSortingTableHead>
            <SortingTable title="RPE" attr="rpe" location={['data', 'event', 'rpe']} bgColor={'#f7f8fa'} sortFunction={toggleSortNumber} />
            <WrapperSortingTableHead border={'none'} cursor={'pointer'} bgColor={'#f7f8fa'}>
              <span onClick={() => togglePopUp('pu_1')}>% Fresh</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['data', 'strength', 'freshTotalRatio']}
                popup_id={'pu_1'}
                visible={popUp}
                includeAlerts={true}
                status={['data', 'strength', 'armFatigueTotal']} />
            </WrapperSortingTableHead>
            <SortingTable
              title="Change (lbs)"
              attr="freshTotalChange"
              location={['data', 'strength', 'freshTotalChange']}
              bgColor={'#f7f8fa'} sortFunction={toggleSortNumber} />
            <WrapperSortingTableHead border={'none'} cursor={'pointer'} bgColor={'#ebedf2'}>
              <span onClick={() => togglePopUp('pu_2')}>% Fresh</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['data', 'strength', 'freshIRRatio']}
                popup_id={'pu_2'}
                visible={popUp}
                includeAlerts={true}
                status={['data', 'strength', 'armFatigueIR']} />
            </WrapperSortingTableHead>
            <SortingTable
              title="Change (lbs)"
              attr="freshIRChange"
              location={['data', 'strength', 'freshIRChange']}
              bgColor={'#ebedf2'} sortFunction={toggleSortNumber} />
            <WrapperSortingTableHead border={'none'} cursor={'pointer'} bgColor={'#f7f8fa'}>
              <span onClick={() => togglePopUp('pu_3')}>% Fresh</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['data', 'strength', 'freshERRatio']}
                popup_id={'pu_3'}
                visible={popUp}
                includeAlerts={true}
                status={['data', 'strength', 'armFatigueER']} />
            </WrapperSortingTableHead>
            <SortingTable
              title="Change (lbs)"
              attr="freshERChange"
              location={['data', 'strength', 'freshERChange']}
              bgColor={'#f7f8fa'} sortFunction={toggleSortNumber} />
            <WrapperSortingTableHead border={'none'} cursor={'pointer'} bgColor={'#ebedf2'}>
              <span onClick={() => togglePopUp('pu_4')}>% Fresh</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['data', 'strength', 'freshScaptionRatio']}
                popup_id={'pu_4'}
                visible={popUp}
                includeAlerts={true}
                status={['data', 'strength', 'armFatigueScaption']} />
            </WrapperSortingTableHead>
            <SortingTable
              title="Change (lbs)"
              attr="freshScaptionChange"
              location={['data', 'strength', 'freshScaptionChange']}
              bgColor={'#ebedf2'} sortFunction={toggleSortNumber} />
            <WrapperSortingTableHead border={'none'} cursor={'pointer'} bgColor={'#f7f8fa'}>
              <span onClick={() => togglePopUp('pu_5')}>% Fresh</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['data', 'strength', 'freshGripRatio']}
                popup_id={'pu_5'}
                visible={popUp}
                includeAlerts={true}
                status={['data', 'strength', 'armFatigueGrip']}
              />
            </WrapperSortingTableHead>
            <SortingTable
              title="Change (lbs)"
              attr="freshGripChange"
              location={['data', 'strength', 'freshGripChange']}
              bgColor={'#f7f8fa'} sortFunction={toggleSortNumber} />
          </TableRow>
        </TableHead>
        <TableBody onClick={() => closeSorts()}>
          {table.length ? (
            <>
              {table
                .map(item => {
                  return (
                    <TableItem
                      item={item}
                      key={item.player._id}
                      hoverInfo={hoverOval}
                      hideTooltip={hideTooltip}
                    />
                  );
                })}
            </>
          ) : (
            <TableRow>
              <TableColumn border={'none'} colSpan={20}>No data</TableColumn>
            </TableRow>
          )}
        </TableBody>
      </TableDefault>
      <TooltipFatigueZones section={tooltipSection} tooltipRef={tooltipRef} />
    </>
  );
};

const TableItem = ({ item, hoverInfo, hideTooltip }) => {
  const MARGIN_RIGHT_FEATURE_LOCKED = 19;
  const dateRef = useRef(0) as any;
  const PlayerRef = useRef(0) as any;

  /** defines where the component should start that limits the basic functionalities */
  const [left, setLeft] = useState<number>(340);

  useLayoutEffect(() => {
    changeScreen();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    }
  }, [])

  const changeScreen = () => {
    /** 19px is added to maintain component margin */
    setLeft(PlayerRef.current.offsetWidth + dateRef.current.offsetWidth + MARGIN_RIGHT_FEATURE_LOCKED);
  }

  return (
    <TableRow style={{ position: 'relative' }}>
      <SelectPlayerColumn PlayerColumnRef={PlayerRef} unClickeable={item.player.plan === 'basic'} bgColor={'#f7f8fa'} player={item.player} cursor={'pointer'} />
      <TableColumn ref={dateRef} border={'none'} bgColor={'#EBEDF2'}>{handleDate(item.data.date)}</TableColumn>
      <TableColumn border={'none'}>{item.player.plan !== 'basic' && capitalizeFirstLetters(item.data.event.type, '_')}</TableColumn>
      <TableColumn border={'none'}>
        {item.player.plan !== 'basic' && (
          item.data.event.type === 'velo_day' ?
            capitalizeFirstLetters(item.data.event.highIntentsThrows, ' ') :
            numberColumnFormatter(item.data.event.pitches, { digits: 0 })
        )}
      </TableColumn>
      <TableColumn border={'none'}>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.event.rpe, { digits: 0 })}</TableColumn>
      <TableColumn border={'none'}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshTotalRatio, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.data.strength.armFatigueTotal, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>
      <TableColumn border={'none'}>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshTotalChange)}</TableColumn>
      <TableColumn border={'none'} bgColor={'#EBEDF2'}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshIRRatio, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.data.strength.armFatigueIR, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>
      <TableColumn border={'none'} bgColor={'#EBEDF2'}>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshIRChange)}</TableColumn>
      <TableColumn border={'none'}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshERRatio, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.data.strength.armFatigueER, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>
      <TableColumn border={'none'}>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshERChange)}</TableColumn>
      <TableColumn border={'none'} bgColor={'#EBEDF2'}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshScaptionRatio, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.data.strength.armFatigueScaption, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>
      <TableColumn border={'none'} bgColor={'#EBEDF2'}>{
        item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshScaptionChange)}
      </TableColumn>
      <TableColumn border={'none'}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshGripRatio, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.data.strength.armFatigueGrip, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>
      <TableColumn border={'none'}>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshGripChange)}</TableColumn>
      {item.player.plan === 'basic' && (
        <FeatureLocked left={left} right={MARGIN_RIGHT_FEATURE_LOCKED}>
          <TitleFeatureLocked>
            Basic Subscription<TextFeatureLocked> - Unlock this data by sponsoring the athlete or have the player purchase a premium subscription</TextFeatureLocked>
          </TitleFeatureLocked>
        </FeatureLocked>
      )}
    </TableRow>
  );
};
